/* Peach State Pottery - ZIP code freight estimator.
   Rates mirror the live Shopify shipping profiles:
     Small / Medium / Large Freight - Kilns & Equipment (zones A-D)
     Pottery Wheels - Flat Rate ($49)
   If a rate changes in Shopify admin > Shipping, change it in RATES below too.
   To put a NEW product on the estimator, either add its handle to HANDLE_TIER
   or add one tag to the product in Shopify admin:
     freight-small | freight-medium | freight-large | freight-wheel
   (a tag always wins over the handle table). */
(function () {
  "use strict";

  var RATES = {
    small:  { A: 225, B: 265, C: 305, D: 345 },
    medium: { A: 340, B: 400, C: 460, D: 520 },
    large:  { A: 460, B: 545, C: 620, D: 700 },
    wheel:  49
  };

  /* 3-digit ZIP prefix -> state. Contiguous US only; AK, HI, PR and military
     ZIPs fall through to the "custom quote" message, matching the profiles. */
  var ZIP_RANGES = [
    [10, 27, "MA"], [28, 29, "RI"], [30, 38, "NH"], [39, 49, "ME"], [50, 59, "VT"],
    [60, 69, "CT"], [70, 89, "NJ"], [100, 149, "NY"], [150, 196, "PA"], [197, 199, "DE"],
    [200, 200, "DC"], [201, 201, "VA"], [202, 205, "DC"], [206, 219, "MD"], [220, 246, "VA"],
    [247, 268, "WV"], [270, 289, "NC"], [290, 299, "SC"], [300, 319, "GA"], [320, 339, "FL"],
    [341, 349, "FL"], [350, 369, "AL"], [370, 385, "TN"], [386, 397, "MS"], [398, 399, "GA"],
    [400, 427, "KY"], [430, 459, "OH"], [460, 479, "IN"], [480, 499, "MI"], [500, 528, "IA"],
    [530, 549, "WI"], [550, 567, "MN"], [570, 577, "SD"], [580, 588, "ND"], [590, 599, "MT"],
    [600, 629, "IL"], [630, 658, "MO"], [660, 679, "KS"], [680, 693, "NE"], [700, 714, "LA"],
    [716, 729, "AR"], [730, 732, "OK"], [733, 733, "TX"], [734, 749, "OK"], [750, 799, "TX"],
    [800, 816, "CO"], [820, 831, "WY"], [832, 838, "ID"], [840, 847, "UT"], [850, 865, "AZ"],
    [870, 884, "NM"], [885, 885, "TX"], [889, 898, "NV"], [900, 961, "CA"], [970, 979, "OR"],
    [980, 994, "WA"]
  ];

  var STATES = {
    AL: ["Alabama", "A"], FL: ["Florida", "A"], GA: ["Georgia", "A"], KY: ["Kentucky", "A"],
    MS: ["Mississippi", "A"], NC: ["North Carolina", "A"], SC: ["South Carolina", "A"], TN: ["Tennessee", "A"],
    AR: ["Arkansas", "B"], DE: ["Delaware", "B"], DC: ["Washington, D.C.", "B"], IL: ["Illinois", "B"],
    IN: ["Indiana", "B"], LA: ["Louisiana", "B"], MD: ["Maryland", "B"], MO: ["Missouri", "B"],
    OH: ["Ohio", "B"], OK: ["Oklahoma", "B"], TX: ["Texas", "B"], VA: ["Virginia", "B"], WV: ["West Virginia", "B"],
    CT: ["Connecticut", "C"], IA: ["Iowa", "C"], KS: ["Kansas", "C"], ME: ["Maine", "C"],
    MA: ["Massachusetts", "C"], MI: ["Michigan", "C"], MN: ["Minnesota", "C"], NE: ["Nebraska", "C"],
    NH: ["New Hampshire", "C"], NJ: ["New Jersey", "C"], NY: ["New York", "C"], ND: ["North Dakota", "C"],
    PA: ["Pennsylvania", "C"], RI: ["Rhode Island", "C"], SD: ["South Dakota", "C"], VT: ["Vermont", "C"],
    WI: ["Wisconsin", "C"],
    AZ: ["Arizona", "D"], CA: ["California", "D"], CO: ["Colorado", "D"], ID: ["Idaho", "D"],
    MT: ["Montana", "D"], NV: ["Nevada", "D"], NM: ["New Mexico", "D"], OR: ["Oregon", "D"],
    UT: ["Utah", "D"], WA: ["Washington", "D"], WY: ["Wyoming", "D"]
  };

  function list(tier, handles) {
    var out = {};
    for (var i = 0; i < handles.length; i++) out[handles[i]] = tier;
    return out;
  }
  function merge() {
    var o = {};
    for (var i = 0; i < arguments.length; i++) for (var k in arguments[i]) o[k] = arguments[i][k];
    return o;
  }

  var HANDLE_TIER = merge(
    list("small", [
      "olympic-kilns-doll-e-test-e-electric-kiln", "olympic-kiln-129e-electric-kiln-quick-ship",
      "olympic-1214-120he-electric-kiln-quick-ship", "olympic-kilns-hb89e-electric-kiln-quick-ship",
      "olympic-kilns-hb86e-electric-kiln", "olympic-kilns-1414he-ceramic-test-kiln",
      "olympic-kilns-hotbox-e-electric-kiln", "olympic-kilns-hb64e-electric-kiln",
      "olympic-kilns-189-slider-glass-firing-kiln", "olympic-kilns-square-149gfe-glass-firing-kiln",
      "olympic-kilns-square-146gfe-glass-kiln", "olympic-kilns-traveler-120v-electric-kiln",
      "olympic-kilns-1414he-freedom-package", "hot-shot-clam-shell-glass-kiln-hs-12g",
      "hot-shot-heat-treating-oven-hs-360", "hot-shot-knife-oven-hs-360k",
      "hot-shot-knife-makers-kiln-hs-18k", "hot-shot-glass-kiln-hs-7gw",
      "hot-shot-vitrigraph-glass-kiln-hs-7gv", "hot-shot-glass-kiln-hs-7g",
      "hot-shot-tempering-oven-hs-360t", "hot-shot-clam-shell-glass-kiln-hs-16g",
      "paragon-sc2-jewelry-glass-kiln", "olympic-1214-120he-electric-kiln-quick-ship-1",
      "olympic-kilns-doll-e-test-e-electric-kiln-quick-ship", "paragon-sc2-pro-kiln",
      "paragon-sc3-digital-kiln", "paragon-bluebird-xl-glass-bead-annealing-kiln",
      "paragon-caldera-digital-kiln", "paragon-knife-oven-km18-heat-treating-furnace",
      "paragon-knife-oven-km14", "paragon-knife-oven-km14-pro", "paragon-knife-oven-km9-pro",
      "paragon-knife-oven-double-barrel-km18-pro", "paragon-double-barrel-km14-pro-knife-oven",
      "paragon-double-barrel-km9-pro-knife-heat-treating-oven", "paragon-knife-oven-double-barrel-km18",
      "paragon-knife-oven-km18-pro", "evenheat-ceramic-kiln-high-fire-810",
      "evenheat-ceramic-kiln-high-fire-1210b", "evenheat-ceramic-kiln-rm-ii-810",
      "evenheat-ceramic-kiln-rm-ii-1210", "evenheat-ceramic-kiln-rm-ii-1210b",
      "evenheat-knife-oven-kh-414", "evenheat-knife-oven-kh-418", "evenheat-heat-treat-oven-lb-18",
      "evenheat-knife-oven-ko-18", "evenheat-heat-treat-oven-ht-1", "evenheat-heat-treat-oven-ht-2",
      "evenheat-glass-kiln-studio-pro-stp", "evenheat-glass-kiln-studio-pro-14",
      "evenheat-glass-kiln-studio-pro-17", "evenheat-glass-kiln-v8", "evenheat-metal-clay-kiln-kingpin-88"
    ]),
    list("medium", [
      "olympic-kilns-mas1823he-electric-kiln", "olympic-kiln-mas2327he-electric-kiln-quick-ship",
      "olympic-1814he-electric-kiln-quick-ship", "olympic-kilns-1823e-electric-raku-kiln",
      "olympic-kilns-champ-xl-glass-kiln-quick-ship", "olympic-kilns-2327g-updraft-gas-kiln",
      "olympic-kilns-1827he-electric-kiln", "olympic-kilns-1823he-electric-kiln",
      "olympic-kilns-1818e-electric-kiln", "olympic-kilns-2318he-electric-kiln",
      "olympic-kilns-1818he-electric-kiln", "olympic-kilns-23-raku-updraft-gas-kiln",
      "olympic-kilns-2327he-electric-kiln", "olympic-kilns-2323he-electric-kiln",
      "olympic-kilns-2023he-oval-electric-kiln", "olympic-kilns-1823he-freedom-package",
      "olympic-kilns-2327he-freedom-package", "hot-shot-heat-treating-oven-hs-1200",
      "hot-shot-clam-shell-glass-kiln-hs-18g", "hot-shot-heat-treating-oven-hs-1200c",
      "hot-shot-18a-the-annealing-cabinet", "hot-shot-knife-oven-hs-1200k",
      "hot-shot-knife-makers-kiln-hs-24k", "hot-shot-clam-shell-glass-kiln-hs-24g",
      "olympic-kiln-mas2327he-electric-kiln-quick-ship-1", "olympic-kilns-1823he-electric-kiln-quick-ship",
      "paragon-knife-oven-km24", "paragon-knife-oven-double-barrel-km24",
      "paragon-double-barrel-knife-oven-km-36-pro", "paragon-knife-oven-double-barrel-km24-pro",
      "paragon-knife-oven-km36-pro", "paragon-knife-oven-km24-pro",
      "evenheat-ceramic-kiln-high-fire-1413", "evenheat-ceramic-kiln-high-fire-1813",
      "evenheat-ceramic-kiln-high-fire-1818", "evenheat-ceramic-kiln-rm-ii-1413",
      "evenheat-ceramic-kiln-rm-ii-1822", "evenheat-ceramic-kiln-rm-ii-2322",
      "evenheat-heat-treat-oven-lb-22-5", "evenheat-heat-treat-oven-lb-27",
      "evenheat-knife-oven-ko-22-5", "evenheat-knife-oven-ko-27", "evenheat-glass-kiln-gts-23"
    ]),
    list("large", [
      "olympic-kilns-fl20e-large-capacity-electric-kiln", "olympic-kilns-fl5-5e-large-capacity-electric-kiln",
      "olympic-kilns-139fle-front-loading-electric-kiln", "olympic-kilns-fl17e-large-capacity-kiln",
      "olympic-kilns-2827he-electric-kiln", "olympic-kilns-dd9-large-capacity-gas-kiln",
      "olympic-kilns-2827g-updraft-gas-kiln", "olympic-kilns-gf15e-large-capacity-glass-fusing-kiln",
      "olympic-kilns-fl53e-large-capacity-kiln", "olympic-kilns-2823he-electric-kiln",
      "olympic-kilns-2827he-freedom-package", "paragon-knife-oven-km54-pro", "paragon-knife-oven-km45-pro",
      "evenheat-ceramic-kiln-rm-ii-2329", "evenheat-ceramic-kiln-rm-ii-2929",
      "olympic-kilns-fl4-5e-large-capacity-kiln", "olympic-kilns-fl8e-large-capacity-kiln",
      "olympic-kilns-fl12e-large-capacity-kiln", "olympic-kilns-fl12e-car-large-capacity-kiln",
      "olympic-kilns-fl17e-car-large-capacity-kiln", "olympic-kilns-fl36e-large-capacity-kiln",
      "olympic-kilns-fl42e-car-large-capacity-kiln", "olympic-kilns-fl53e-car-large-capacity-kiln",
      "olympic-kilns-1818fle-front-loading-electric-kiln"
    ]),
    list("wheel", [
      "speedball-artista-pottery-wheel", "speedball-clay-boss-pottery-wheel",
      "speedball-big-boss-elite-sq-pottery-wheel", "speedball-big-boss-pottery-wheel"
    ]),
    /* Added Sep 24: products assigned to Small freight profile */
    list("small", [
      "paragon-home-artist-portable-raku-kiln", "evenheat-heat-treat-oven-cube-7", "evenheat-tempering-oven-lt-18",
      "evenheat-salt-bath-709", "evenheat-salt-bath-718", "evenheat-salt-bath-818",
      "evenheat-copper-annealing-kiln", "paragon-quikfire-vi-test-kiln", "paragon-q11-multipurpose-kiln",
      "paragon-j11-xpress-jewelry-kiln", "paragon-j14-xpress-jewelry-kiln", "paragon-e9-enameling-and-china-painting-kiln",
      "paragon-e10-enameling-and-china-painting-kiln", "paragon-e12t-enameling-and-china-painting-kiln", "paragon-e14-enameling-and-china-painting-kiln",
      "paragon-double-barrel-knife-oven-km9", "paragon-double-barrel-knife-oven-km14", "olympic-kilns-tophat-189e-electric-kiln",
      "olympic-kilns-tophat-1214e-raku-e-electric-kiln", "paragon-ht14-heat-treating-kiln", "paragon-pmt10-heat-treating-kiln",
      "paragon-pmt13-heat-treating-kiln", "paragon-pmt18-heat-treating-kiln", "olympic-kilns-hb84e-electric-kiln",
      "olympic-kilns-1214-120e-electric-kiln", "paragon-vitrigraph-crucible-kiln", "paragon-f120-glass-annealing-kiln",
      "paragon-f130-glass-annealing-kiln", "paragon-fusion-7-glass-fusing-kiln", "paragon-cs14s-clam-shell-glass-fusing-kiln",
      "paragon-fusion-14-glass-fusing-kiln", "paragon-cs14d-dual-clam-shell-glass-fusing-kiln", "paragon-cs16s-clam-shell-glass-fusing-kiln",
      "paragon-fusion-16-glass-fusing-kiln", "paragon-tlc16-glass-fusing-kiln", "paragon-cs16d-dual-clam-shell-glass-fusing-kiln",
      "paragon-fusion-8-glass-fusing-kiln", "paragon-fusion-17-bottle-slump-glass-fusing-kiln"
    ]),
    /* Added Sep 24: products assigned to Medium freight profile */
    list("medium", [
      "olympic-kilns-mas1818he-electric-kiln", "olympic-kilns-dm2327he-electric-kiln", "olympic-kilns-2527he-oval-electric-kiln",
      "paragon-knife-oven-km36", "evenheat-ceramic-kiln-rm-ii-1813", "paragon-fusion-19-glass-fusing-kiln",
      "evenheat-knife-oven-kf-31-5-extreme", "evenheat-ceramic-kiln-rm-ii-2522", "evenheat-knife-oven-kf-36-extreme",
      "evenheat-ceramic-kiln-high-fire-2318", "evenheat-ceramic-kiln-high-fire-2327", "evenheat-tempering-oven-lt-22-5",
      "evenheat-tempering-oven-lt-27", "evenheat-glass-kiln-studio-pro-24", "evenheat-glass-kiln-gts-17",
      "evenheat-glass-kiln-gts-18", "evenheat-glass-kiln-gts-24", "paragon-ct81713-ceramic-kiln",
      "paragon-ct81722-ceramic-kiln", "paragon-ct102322-ceramic-kiln", "olympic-kilns-mas2323he-electric-kiln",
      "olympic-kilns-dm1818he-electric-kiln", "olympic-kilns-dm1823he-electric-kiln", "olympic-kilns-dm2323he-electric-kiln",
      "paragon-double-barrel-knife-oven-km36", "olympic-kilns-2018he-oval-electric-kiln", "olympic-kilns-2518he-oval-electric-kiln",
      "olympic-kilns-2027he-oval-electric-kiln", "paragon-km25-vertical-base-knife-heat-treating-oven", "olympic-kilns-2523he-oval-electric-kiln",
      "olympic-kilns-1827e-electric-kiln", "olympic-kilns-2331he-electric-kiln", "paragon-ht22-heat-treating-kiln",
      "paragon-pmt21-heat-treating-kiln", "paragon-f200-glass-annealing-kiln", "paragon-f240-glass-annealing-kiln",
      "olympic-kilns-tophat-2314e-electric-kiln", "olympic-kilns-dm2318he-electric-kiln", "olympic-kilns-dm2023he-electric-kiln",
      "olympic-kilns-dm2523he-electric-kiln", "paragon-cs19s-clam-shell-glass-fusing-kiln", "paragon-cs19d-dual-clam-shell-glass-fusing-kiln"
    ]),
    /* Added Sep 24: products assigned to Large freight profile */
    list("large", [
      "olympic-kilns-mas2823he-electric-kiln", "paragon-iguana-front-loading-kiln", "paragon-dragon-24-front-loading-kiln",
      "olympic-kilns-fl24e-large-capacity-electric-kiln", "olympic-kilns-dd12-gas-kiln", "paragon-knife-oven-km45",
      "evenheat-knife-oven-kf-40-5-extreme", "evenheat-knife-oven-kf-45-extreme", "evenheat-knife-oven-kf-49-5-extreme",
      "evenheat-ceramic-kiln-rm-ii-2541", "evenheat-ceramic-kiln-high-fire-2918", "evenheat-ceramic-kiln-high-fire-2927",
      "evenheat-glass-kiln-studio-pro-28", "evenheat-glass-kiln-studio-pro-41", "evenheat-glass-kiln-gts-28",
      "evenheat-glass-kiln-gts-41", "evenheat-glass-kiln-gts-2541", "paragon-ct102329-ceramic-kiln",
      "paragon-ct102329-viking-ceramic-kiln", "paragon-ct122822-ceramic-kiln", "paragon-ct122829-ceramic-kiln",
      "paragon-ct122822-viking-ceramic-kiln", "paragon-ct122829-viking-ceramic-kiln", "paragon-ct122822-janus-ceramic-and-glass-kiln",
      "paragon-super-dragon-27-front-loading-kiln", "olympic-kilns-mas2827he-electric-kiln", "olympic-kilns-dm2827he-electric-kiln",
      "paragon-double-barrel-knife-oven-km45", "paragon-double-barrel-knife-oven-km54", "paragon-knife-oven-double-barrel-km45-pro",
      "olympic-kilns-dm3023he-electric-kiln", "paragon-knife-oven-double-barrel-km54-pro", "olympic-kilns-2827e-electric-kiln",
      "olympic-kilns-2831he-electric-kiln", "olympic-kilns-dd17-gas-kiln", "olympic-kilns-2831g-gas-kiln",
      "olympic-kilns-tophat-2814e-electric-kiln", "olympic-kilns-dm2818he-electric-kiln", "olympic-kilns-tophat-2827e-electric-kiln",
      "olympic-kilns-dm3018he-electric-kiln", "paragon-f500-glass-annealing-kiln", "paragon-f500-pro-glass-annealing-kiln"
    ]),
    /* Re-tiered Sep 24 (later entries win) */
    list("small", [
      "hot-shot-heat-treating-oven-hs-1200", "hot-shot-heat-treating-oven-hs-1200c", "hot-shot-knife-oven-hs-1200k",
      "olympic-kilns-139fle-front-loading-electric-kiln", "evenheat-ceramic-kiln-high-fire-1413", "evenheat-ceramic-kiln-rm-ii-1413",
      "evenheat-glass-kiln-gts-17", "olympic-kilns-champ-xl-glass-kiln-quick-ship"
    ]),
    list("medium", [
      "olympic-kilns-1818fle-front-loading-electric-kiln", "evenheat-heat-treat-oven-ht-2", "olympic-kilns-189-slider-glass-firing-kiln",
      "paragon-f500-glass-annealing-kiln", "paragon-f500-pro-glass-annealing-kiln"
    ]),
    list("large", [
      "olympic-kilns-2331he-electric-kiln", "olympic-kilns-2518he-oval-electric-kiln", "olympic-kilns-2523he-oval-electric-kiln",
      "olympic-kilns-2527he-oval-electric-kiln", "olympic-kilns-dm2523he-electric-kiln", "evenheat-ceramic-kiln-rm-ii-2522"
    ])
  );

  var STORE_KEY = "psp_ship_zip";

  function zipToState(zip) {
    var n = parseInt(zip.slice(0, 3), 10);
    for (var i = 0; i < ZIP_RANGES.length; i++) {
      if (n >= ZIP_RANGES[i][0] && n <= ZIP_RANGES[i][1]) return ZIP_RANGES[i][2];
    }
    return null;
  }

  function tierFromTags(str) {
    var tags = (str || "").toLowerCase().split(",");
    for (var i = 0; i < tags.length; i++) {
      var t = tags[i].trim();
      if (t === "freight-small") return "small";
      if (t === "freight-medium") return "medium";
      if (t === "freight-large") return "large";
      if (t === "freight-wheel") return "wheel";
    }
    return null;
  }

  function money(n) {
    return "$" + Math.round(n).toLocaleString("en-US");
  }

  function currentPrice() {
    var el = document.querySelector(".product-details .product-pricing .price--main") ||
             document.querySelector(".product-details .price--main");
    if (!el) return null;
    var m = (el.textContent || "").match(/\$\s*[0-9][0-9,]*(\.[0-9]+)?/g);
    if (!m) return null;
    var n = parseFloat(m[m.length - 1].replace(/[^0-9.]/g, ""));
    return isFinite(n) && n > 0 ? n : null;
  }

  function save(zip) { try { window.localStorage.setItem(STORE_KEY, zip); } catch (e) {} }
  function load() { try { return window.localStorage.getItem(STORE_KEY) || ""; } catch (e) { return ""; } }

  function init(root) {
    if (root.getAttribute("data-psp-ready") === "1") return;
    root.setAttribute("data-psp-ready", "1");

    var tier = tierFromTags(root.getAttribute("data-product-tags")) ||
               HANDLE_TIER[root.getAttribute("data-product-handle") || ""];
    if (!tier) { root.hidden = true; return; }
    root.hidden = false;

    var input = root.querySelector("[data-psp-zip-input]");
    var form = root.querySelector("[data-psp-zip-form]");
    var out = root.querySelector("[data-psp-zip-result]");
    var noun = tier === "wheel" ? "shipping" : "freight";

    function render(zip, userAction) {
      if (!/^\d{5}$/.test(zip)) {
        if (userAction) out.innerHTML = '<p class="psp-ship__err">Please enter a 5-digit ZIP code.</p>';
        return;
      }
      var st = zipToState(zip);
      if (!st) {
        out.innerHTML = '<p class="psp-ship__err">That ZIP is outside our flat-rate area (Alaska, Hawaii, ' +
          'territories and military addresses). <a href="tel:+14702643563">Call or text (470) 264-3563</a> ' +
          'and we’ll get you a delivered price.</p>';
        return;
      }
      save(zip);
      var name = STATES[st][0];
      var rate = tier === "wheel" ? RATES.wheel : RATES[tier][STATES[st][1]];
      var price = currentPrice();
      var html = '<div class="psp-ship__row"><span>Estimated ' + noun + ' to ' + name + ' (' + zip + ')</span>' +
                 '<strong>' + money(rate) + '</strong></div>';
      if (price) {
        html += '<div class="psp-ship__row psp-ship__row--total"><span>Estimated delivered price</span>' +
                '<strong>' + money(price + rate) + '</strong></div>';
      }
      var notes = [];
      if (tier !== "wheel") notes.push("Liftgate included when needed");
      if (st !== "GA") notes.push("No sales tax to " + name);
      notes.push("Final rate confirmed at checkout");
      html += '<p class="psp-ship__note">' + notes.join(" &middot; ") + '</p>';
      out.innerHTML = html;
    }

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      render((input.value || "").trim(), true);
    });

    var saved = load();
    if (saved) { input.value = saved; render(saved, false); }

    /* Keep the delivered total in sync if the shopper switches variants. */
    var priceEl = document.querySelector(".product-details .product-pricing .price--main") ||
                  document.querySelector(".product-details .price--main");
    if (priceEl && window.MutationObserver) {
      new MutationObserver(function () {
        var z = (input.value || "").trim();
        if (out.innerHTML && /^\d{5}$/.test(z)) render(z, false);
      }).observe(priceEl, { childList: true, subtree: true, characterData: true });
    }
  }

  function scan() {
    var nodes = document.querySelectorAll("[data-psp-ship]");
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", scan);
  else scan();
})();
